import React from 'react';
import {
    clearChunkReloadFlag,
    isChunkLoadError,
    isOffline,
    resetFailedLazyRoutes,
} from '../../utils/lazyWithRetry';

const describeError = (error) => {
    if (!isChunkLoadError(error)) {
        return {
            title: 'Не удалось открыть раздел',
            text: 'В этом разделе произошла ошибка. Черновики форм сохранены.',
        };
    }
    if (isOffline()) {
        return {
            title: 'Нет подключения к интернету',
            text: 'Этот раздел ещё не загружен. Подключитесь к сети и повторите попытку.',
        };
    }
    return {
        title: 'Не удалось загрузить раздел',
        text: 'Проверьте подключение и повторите попытку.',
    };
};

/** Ошибка раздела не должна убирать меню и шапку: показываем её вместо содержимого маршрута. */
class RouteErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
        this.handleRetry = this.handleRetry.bind(this);
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error) {
        console.error('Ошибка раздела:', error);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
            this.handleRetry();
        }
    }

    handleRetry() {
        // Повтор по кнопке снова разрешает одну перезагрузку: сеть могла вернуться уже после выкладки
        clearChunkReloadFlag();
        resetFailedLazyRoutes();
        this.setState({ error: null });
    }

    render() {
        if (!this.state.error) {
            return this.props.children;
        }

        const { title, text } = describeError(this.state.error);
        return (
            <div role="alert" style={{ padding: '3rem 1rem', textAlign: 'center' }}>
                <h2>{title}</h2>
                <p>{text}</p>
                <button type="button" className="btn btn-primary" onClick={this.handleRetry}>
                    Повторить
                </button>
            </div>
        );
    }
}

export default RouteErrorBoundary;
